export default __webpack_public_path__ + "static/media/balao_magico.aceb18d0.png";